import * as React from 'react';

import type { CheckboxProps, FormControlLabelProps } from '@mui/material';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export type LookoCheckboxType = {
  /** 체크박스를 비활성화할지 여부다. */
  disabled?: boolean;
  /** 체크박스 옆에 표시할 내용이다. */
  label?: React.ReactNode;
  /** form 제출과 변경 이벤트에 사용할 체크박스 값이다. */
  value?: FormControlLabelProps['value'];
  /** 체크박스의 선택 상태다. */
  checked?: boolean;
  /** 선택 상태가 변경될 때 호출한다. */
  onChange?: FormControlLabelProps['onChange'];
  /** 내부 native checkbox input에 전달할 접근성·HTML 속성이다. */
  inputProps?: CheckboxProps['inputProps'];
};

/**
 * 체크박스.
 *
 * ```tsx
 * // 선택됨
 * <LookoCheckbox label="항목" checked={true} onChange={handleChange} />
 * // 선택 안됨
 * <LookoCheckbox label="항목" checked={false} onChange={handleChange} />
 * // 비활성화
 * <LookoCheckbox label="항목" checked={true} disabled />
 * ```
 *
 * @param props 표시 내용, 선택 상태와 native input 속성
 * @returns Looko 크기와 텍스트 스타일이 적용된 체크박스
 */
export const LookoCheckbox = (props: LookoCheckboxType) => {
  const { inputProps, ...formControlLabelProps } = props;

  return (
    <FormControlLabel
      {...formControlLabelProps}
      label={<Typography variant="Body_Looko">{props.label}</Typography>}
      control={
        <Checkbox
          inputProps={inputProps}
          size="small"
          sx={{
            padding: 0.5,
            margin: 0,
            width: 32,
            height: 32,
          }}
        />
      }
      sx={{ margin: 0 }}
    />
  );
};
